import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import firmReducer from './components/shared/redux/firmSlicer';
import firmListReducer from './components/shared/redux/firmListSlicer';
import companyListReducer from './components/shared/redux/companySlicer';
import currentRealmReducer from './components/shared/redux/currentRealmSlicer';
import currentUserReducer from './components/shared/redux/userSlicer';
import currentSubscriptionReducer from './components/shared/redux/subscriptionSlicer';

// НОВОЕ: appSlice
import appReducer from './appSlice'; // путь поправьте под ваше размещение файла

const rootReducer = combineReducers({
  // НОВОЕ: добавили редьюсер приложения
  app: appReducer,

  currentFirm: firmReducer,
  firmList: firmListReducer,
  companyList: companyListReducer,
  currentRealm: currentRealmReducer,
  currentUser: currentUserReducer,
  currentSubscription: currentSubscriptionReducer
});

const persistConfig = {
  key: 'root',
  storage,
  // Не сохраняем служебные флаги приложения (loading/initialized/error)
  blacklist: ['app']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER']
      }
    })
});

export const persistor = persistStore(store);

// Типы
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// (опционально) типизированные хуки
export const createAppHooks = () => {
  // Чтобы не тянуть react-redux тут, обычно делают отдельный файл hooks.ts
  return null;
};

export default store;
